
import { arrayOf, nullable, oneOfType, shape, string } from 'vue-types';
import { imageShape } from '~/constants/PropTypes';
export default {
  props: {
    title: oneOfType([string(), nullable()]),
    slides: arrayOf(
      shape({
        id: string(),
        heading: oneOfType([string(), nullable()]),
        body: oneOfType([string(), nullable()]),
        visual: arrayOf(shape(imageShape).loose),
      }).loose
    ).def([]),
  },
  data() {
    return {
      activeIndex: 0,
      sliderOffset: 0,
      sliderInterval: null,
    };
  },
  computed: {
    lastIndex() {
      return this.slides?.length ? this.slides.length - 1 : 0;
    },
    progress() {
      const progress = this.activeIndex / this.slides?.length;

      return progress;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.sliderInterval = setInterval(() => {
        this.activeIndex =
          this.activeIndex + 1 >= this.slides.length ? 0 : this.activeIndex + 1;
      }, 3000);
    });
  },
  destroyed() {
    this.sliderInterval && clearInterval(this.sliderInterval);
  },
  methods: {
    initSlider(slider) {
      this.slider = slider;
    },
    onSlideChange() {
      if (!this.slider) {
        return;
      }

      const { realIndex } = this.slider;
      const index = (realIndex + 1) % this.slides?.length;

      this.activeIndex = index;
    },
  },
};
